import React, { useEffect, useContext } from 'react';
import Helmet from 'react-helmet';

import Layout from '../../components/layout';

import PAGE_HEADER_ITEMS from './data/interest-free-header.json';
import CarouselHeader from '@/components/Carousel/carouselHeader';
import StickyNavigationBranded from '@/components/StickyNavigation/StickyNavigationBranded';
import HereToHelpSection from './_hereToHelp';
import FindAnOfferSection from './_findAnOffer';
import { PageContext } from '@/context/PageContext';
import { 
  CONTENTFUL_COMPONENTS,
  BREAKPOINT
 } from '@/utils/constants';
import HeroBanner from '@/components/lab-components/HeroBanner';
import IFExplainer from '@/components/lab-components/IFExplainer';
import Section from '@latitude/section';
import { useSetState } from '@/utils/hooks';
import '@/components/PageLayout/pageHeader.css';
import { AnalyticsContext } from 'latitude-analytics';
import pageData from '@/data/pages/interest-free/index.json';
import ImportantInformationSection from './_importantInformation';
import PromoBannerCarousel from '@/components/PromoBannerRebrandCarousel/PromoBannerCarouselRebrand';
import StandaloneText from '@/components/lab-components/StandaloneText';

function FindAnOfferPage(props) {
  /** Contentful Data */
  const contentfulPageData = useContext(PageContext);
  const state = contentfulPageData?.updatedBody || {};
  /** - END - */

  const [analytics] = useContext(AnalyticsContext);
  useEffect(()=> {
    const sourceCode = localStorage.getItem('source_code') || 'IDAAA';
    // adding pageData to analytics
    analytics.pageData = {
      page_pageTitle: 'find-an-offer',
      page_pageType: 'information-page',
      page_siteSection: 'interest-free',
      page_siteSubsection: 'find-an-offer',
      product_productid: ['CCAUGOM', 'CCAUGEM'],
      application_sourcecode: sourceCode || 'IDAAA'
    };
  },[])

  return (
    <Layout location={props.location}>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.latitudefinancial.com.au/interest-free/find-an-offer/"
        />
        <title>
          0% Interest Payment Plans At Australian Retailers | Latitude
        </title>
        <meta
          name="description"
          content="Explore the best Interest Free shopping deals and payment plans. Find offers that suit your lifestyle and budget with Latitude."
        />
      </Helmet>

      <main className="navigation-spacer" css="background-color: #f8f8f8;">
        {state?.heroBannerData?.[0] ? (
          <HeroBanner {...state?.heroBannerData[0]} />
        ) : (
          <CarouselHeader HEADER_ITEMS={PAGE_HEADER_ITEMS} />
        )}
        <div
          className="d-none d-lg-block"
          css={`
            position: relative;
            z-index: 10;
          `}
        >
          <StickyNavigationBranded
            items={[
              {
                anchor: 'find-an-offer',
                label: 'Find an offer'
              },
              {
                anchor: 'how-plans-work',
                label: 'Plan types'
              }
            ]}
            offsetElem="[data-sticky-navigation-offset]"
            trackEventData={{
              category: 'cta',
              action: 'quote-link',
              location: 'sticky'
            }}
            trackId="sticky-get-started"
            {...state?.inPageNavData?.[0]}
          />
        </div>
        {state?.standaloneTextData?.[0] && (
          <StandaloneText {...state?.standaloneTextData?.[0]} />
        )}
        
        {state?.promoBannerData?.[0] && <PromoBannerCarousel {...state?.promoBannerData[0]} />}

        <FindAnOfferSection id="find-an-offer" />
        <Section
          id="how-plans-work"
          css={`
            && {
              padding: 32px 0px;
              background-color: #f2f2f2;
              .if-explainer-tile-content-title .typography__h3 {
                font-size: 1.5rem;
              }
              .if-explainer-description .typography__p--subtitle {
                padding: 16px 0px;
                margin: 0px;
              }
              .if-explainer-tile {
                min-height: auto;
              }
            }
          `}
        >
          <IFExplainer
            data={
              state?.ifExplainerCollectionData?.[0] ||
              pageData?.contentful?.ifExplainerCollectionData?.[0]
            }
          />
        </Section>
        <HereToHelpSection id="here-to-help" />
         <ImportantInformationSection
            contentfulData={state?.importantInfoData?.[0]}
          />
      </main>
    </Layout>
  );
}

export default FindAnOfferPage;
